import React from "react";
import injectSheet from "react-jss";
import { Switch, Redirect, Route } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import {
  Budget,
  BudgetError,
  Configuration,
  Home,
  Plot,
  HouseType,
  NotFound,
  Offer,
  OfferForm,
  OfferRequested,
} from "../../";

const MainContent = (props) => {
  const { classes, currentPath, location, offerIncomplete, theme } = props;

  return (
    <div className={`${classes.mainContainer}`}>
      <TransitionGroup>
        <CSSTransition
          key={currentPath[0]}
          classNames="slide"
          timeout={theme.speed.slow}
        >
          <Switch location={location}>
            <Route exact path="/" render={() => <Home {...props} />} />
            <Route path="/bauland" component={Plot} />
            <Route path="/budget" component={Budget} />
            <Route path="/budget-error" component={BudgetError} />
            <Route
              path="/haustyp"
              render={() => <HouseType currentPath={currentPath} />}
            />
            <Route
              path="/konfiguration"
              render={() => <Configuration currentPath={currentPath} />}
            />
            <Route
              path="/angebot"
              render={() =>
                offerIncomplete &&
                location.pathname === window.location.pathname ? (
                  <Redirect to="/angebot-anfordern" />
                ) : (
                  <Offer />
                )
              }
            />
            <Route path="/angebot-anfordern" component={OfferForm} />
            <Route path="/angebot-angefordert" component={OfferRequested} />
            <Route component={NotFound} />
          </Switch>
        </CSSTransition>
      </TransitionGroup>
    </div>
  );
};

const styles = (theme) => ({
  mainContainer: {
    height: "100%",
    width: "100%",
    position: "relative",
    "& .slide-enter": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      transform: "translateY(-150px)",
      opacity: 0,
      "& .appear-element": {
        transform: "translateY(-150px)",
        opacity: 0,
      },
    },
    "& .slide-enter.slide-enter-active": {
      opacity: 1,
      transform: "translateY(0)",
      transition: [
        {
          property: "opacity",
          duration: theme.speed.veryFast,
          delay: theme.speed.fast,
          timingFunction: theme.motion.deceleration,
        },
        {
          property: "transform",
          duration: theme.speed.fast,
          delay: theme.speed.fast,
          timingFunction: theme.motion.deceleration,
        },
      ],
      "& .appear-element": {
        transform: "translateY(0)",
        opacity: 1,
        transition: [
          {
            property: "opacity",
            duration: theme.speed.veryFast,
            delay: theme.speed.fast,
            timingFunction: theme.motion.deceleration,
          },
          {
            property: "transform",
            duration: theme.speed.fast,
            delay: theme.speed.fast,
            timingFunction: theme.motion.deceleration,
          },
        ],
      },
    },
    "& .slide-exit": {
      top: 0,
      left: 0,
      width: "100%",
      opacity: 0,
      transform: "translateY(-150px)",
      transition: [
        {
          property: "opacity",
          duration: theme.speed.veryFast,
          timingFunction: theme.motion.acceleration,
        },
        {
          property: "transform",
          duration: theme.speed.fast,
          timingFunction: theme.motion.acceleration,
        },
      ],
      "& .appear-element": {
        transform: "translateY(-150px)",
        opacity: 0,
        transition: [
          {
            property: "opacity",
            duration: theme.speed.veryFast,
            timingFunction: theme.motion.acceleration,
          },
          {
            property: "transform",
            duration: theme.speed.veryFast,
            timingFunction: theme.motion.acceleration,
          },
        ],
      },
    },
  },
});

export default injectSheet(styles)(MainContent);



// WEBPACK FOOTER //
// ./src/modules/core/components/mainContent.jsx